import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { useAppSelector } from '@platform/state/hooks';
import { selectUi } from '@platform/state/selectors';
import { CategoryRail } from './CategoryRail';
import type { IModulesRailProps } from './IModulesRailProps';
import { useModulesQuery } from './useModulesQuery';
import '@platform/engine/menu/menu.css';

/**
 * Ліва колонка «Усіх модулів» (прототип v4, «Module categories»): «Робочий простір / Усі модулі» і колонка категорій (CategoryRail);
 * вибрана категорія й запит — в адресі сторінки (?group=, ?q=).
 */
export function ModulesRail({ ws }: IModulesRailProps) {
  const { t } = useTranslation();
  const { group, q, setGroup } = useModulesQuery();
  const collapsed = useAppSelector((s) => selectUi(s).leftMenuCollapsed);
  return (
    <aside className={cx('po-menu mnav', collapsed && 'is-collapsed')} aria-label={t('allModules.categories')}>
      <nav className="po-menu__nav mnav__nav" aria-label={t('allModules.categories')}>
        <div className="mnav__head"><span className="mnav__eyebrow">{t('shell.workspace')}</span><span className="mnav__title">{t('allModules.title')}</span></div>
        <CategoryRail ws={ws} q={q} group={group} onPick={setGroup} />
      </nav>
    </aside>
  );
}
